module.exports = __webpack_public_path__ + "static/img/t1-2.1755a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/t1-2.jpg
// module id = AEXL
// module chunks = 1